import Vue from 'vue'
import App from './App.vue'
import Lazy from 'vue-lazyload'
import i18n from './i18n';
import store from './store';
import { router } from './router';
import { isMobile } from './util'

Vue.config.productionTip = false

Vue.use(Lazy, {
  preLoad: 1.3,
  attempt: 1,
})

Vue.prototype.$isMobile = isMobile();

Vue.prototype.$isIos = () => {
  return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
}

fetch("./data.json").then(res => {
  res.json().then(rst => {
    new Vue({
      router,
      i18n,
      store,
      el: '#app',
      render: h => h(App),
      beforeCreate() {
        Vue.prototype.$globalData = rst
      }
    }).$mount('#app')
  })
})



